import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import HistoricalReportView from "./HistoricalReportView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import ContextMenu from "../../../components/contextMenu";
import {HISTORICAL_REPORT_ROUTE, SEND_CONFIRMATION_REPORT_ROUTE} from "../../../utils/constants/RoutesConstants";
import {dateFormatterReportTable} from "../../../utils/formatters/Date";

export default class HistoricalReportContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "fechaConsulta", header: "Fecha Consulta", body: dateFormatterReportTable},
            {field: "folioOperacion", header: "Folio", style: {textAlign: 'right', width: '100px'}},
            {field: "fechaConcertacion", header: "Fecha Concert", body: dateFormatterReportTable},
            {field: "fechaValor", header: "Fecha Valor", body: dateFormatterReportTable},
            {field: "horaConcertacion", header: "Hora Concertación"},
            {field: "fechaVencimiento", header: "Fecha Vencimiento", body: dateFormatterReportTable},
            {field: "plazoOperacion", header: "Plazo", style: {textAlign: 'right', width: '50px'}},
            {field: "instPTM", header: "PTM"},
            {field: "cuentaPTM", header: "Cuenta PTM"},
            {field: "instPTT", header: "PTT"},
            {field: "emisora", header: "Emisora"},
            {field: "tipoValor", header: "Clave"},
            {field: "serie", header: "Serie"},
            {field: "cupon", header: "Cupón"},
            {field: "cantidadTitulos", header: "Títulos", style: {textAlign: 'right', width: '100px'}},
            {field: "monedaOperacion", header: "Moneda"},
            {field: "precioPactado", header: "Precio", style: {textAlign: 'right', width: '100px'}},
            {field: "sobretasa", header: "Sobretasa", style: {textAlign: 'right', width: '70px'}},
            {field: "importe", header: "Importe", style: {textAlign: 'right', width: '100px'}},
            {field: "tasa", header: "Tasa", style: {textAlign: 'right', width: '60px'}},
            {field: "premio", header: "Premio", style: {textAlign: 'right', width: '100px'}},
            {field: "status", header: "Estatus", style: {textAlign: 'left', width: '60px'}},
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            filters: {
                guaranteeCheck: true,
                accountColumn: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            dataReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
            selectedRow: {},


            first: 0,
            rows: 50,
            totalRecords: 0,
            loadingPage: false,
            dataReportTable: [],
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.historicalReportActionTemplate = this.historicalReportActionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.sendConfirmation = this.sendConfirmation.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
        this.getDataReport = this.getDataReport.bind(this);

        this.onVirtualScroll = this.onVirtualScroll.bind(this);
        this.loadChunk = this.loadChunk.bind(this);
        this.loadingText = this.loadingText.bind(this);
    }

    onVirtualScroll(event) {
        this.setState({
            loadingPage: true,
        });
        setTimeout(() => {
           if ((event.first + event.rows) > this.state.totalRecords){
               this.setState({
                   dataReportTable: this.loadChunk(this.state.dataReport, event.first, this.state.totalRecords - event.first),
                   loadingPage: false,
               })
           }else{
               this.setState({
                   dataReportTable: this.loadChunk(this.state.dataReport, event.first, event.rows),
                   loadingPage: false,
               })
           }
        }, 250);
    }

    loadChunk(dataReportAux, index, length) {
        let chunk = [];
        let expandedRowsAux = [];
        for (let i = 0; i < length; i++) {
            chunk[i] = {...dataReportAux[index + i], ...{vin: (index + i)}};
        }
        if (this.state.filters.guaranteeCheck) {
            chunk.map((row) => {
                return (row.guaranteesList.length === 0 ? '' : expandedRowsAux.push(row));
            });
            this.setState({
                expandedRows:expandedRowsAux,
            })
        }
        return chunk;
    }

    loadingText() {
        return <span className="loading-text"/>;
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        let colsAux = JSON.parse(JSON.stringify(this.state.cols));
        this.state.cols.forEach((item)=>{
            if(item.field === "cuentaIndeval"){
                colsAux.splice(2, 1);
            }
        });
        this.setState({
            cols: colsAux,
            filters: {
                guaranteeCheck: true,
                accountColumn: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
        });
    }

    onChangeFilters(event) {
        let colsAux = this.state.cols;
        let filtersAux = this.state.filters;

        switch (event.target.name) {
            case "accountColumn":
                event.checked ?
                    colsAux.splice(2, 0,
                        {field: "cuentaIndeval", header: "Cuenta Indeval"}) :
                    colsAux.splice(2, 1);
                filtersAux[event.target.name] = event.checked;
                break;
            case "guaranteeCheck":
                filtersAux[event.target.name] = event.checked;
                break;
            case "startDate":
                filtersAux[event.target.name] = event.target.value;
                filtersAux['finalDate'] = event.target.value;
                break;
            default:
                filtersAux[event.target.name] = event.target.value;
                break;
        }

        this.setState({
            cols: colsAux,
            filters: filtersAux,
        });
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.guaranteesList;
        return (
            <div className="p-grid">
                <div className="p-col-1"/>
                <div className="p-col-11">
                    <DataTable
                        tableClassName={"guarantees-column-header"}
                        value={guaranteesItems}
                        responsive={true}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="date" header="Fecha" style={{textAlign: 'left'}} body={dateFormatterReportTable}
                                sortable={true}/>
                        <Column field="source" header="Origen" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="type" header="Tipo" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="coin" header="Moneda" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="emisora" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="clave" header="Clave" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="serie" header="Serie" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cupon" header="Cupón" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cuentaPTT" header="Cuenta PTT" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="titles" header="Títulos" style={{textAlign: 'right'}} sortable={true}/>
                        <Column field="price" header="Precio" style={{textAlign: 'right'}} sortable={true}/>
                        <Column field="guaranteeAmount" header="Imp. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="guaranteeTotal" header="Tot. Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                        <Column field="guaranteePercentage" header="% Garantizado" style={{textAlign: 'right'}}
                                sortable={true}/>
                    </DataTable>
                </div>
            </div>
        );
    }

    historicalReportActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Envía Confirmación", action: this.sendConfirmation},
            {
                label: "Exporta Confirmación", action: () => {
                    this.openConfirmationMessage("Confirmation")
                }
            },
        ];
        return (rowData['status'] !== 'FecValor' ?
                <ContextMenu menuOptions={optionsMenu}/> : ""
        );
    }

    onSelectionChange(event) {
        this.setState({
            selectedRow: event.value,
        });
    }

    sendConfirmation() {
        this.props.history.push({
            pathname: SEND_CONFIRMATION_REPORT_ROUTE,
            state: {
                returnPath: HISTORICAL_REPORT_ROUTE,
                reportSelected: this.state.selectedRow,
            },
        });
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType,
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true)
        this.setState({
            loadingPage: true,
            disabledSearchButton: true,
        });
        this.reportsService.getHistoricalReport(this.state.filters)
            .then(resp => {
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: resp.error
                    });
                    this.setState({
                        dataReport: resp.payload,
                    });
                } else {
                    let initialRows = resp.payload.length <= this.state.rows ?
                        resp.payload.length : this.state.rows;
                    let dataReportAux = this.loadChunk(resp.payload, 0, initialRows);

                    this.setState({
                        dataReport: resp.payload,
                        totalRecords: resp.payload.length,
                        dataReportTable: dataReportAux,
                        loadingPage: false,
                    });
                }
                this.setState({disabledSearchButton: false})
                this.loading(false);
            });
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                bandera: 0,
                tipoReporte: 5,
                fechaInicial: this.state.filters.startDate.getFullYear() + "-" +
                    (this.state.filters.startDate.getMonth() + 1) + "-" +
                    this.state.filters.startDate.getDate(),
                fechaFinal: this.state.filters.finalDate.getFullYear() + "-" +
                    (this.state.filters.finalDate.getMonth() + 1) + "-" +
                    this.state.filters.finalDate.getDate(),
                cuenta: this.state.filters.accountColumn,
                chkGarantia: this.state.filters.guaranteeCheck,
            };
            switch (this.state.typeDocument) {
                case "Excel":
                    this.reportsService.getHistoricalReportXLS(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getHistoricalReportPDF(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "CSV":

                    params = {
                        accion:18012,//accion en servlet
                        band:this.state.filters.guaranteeCheck,//con garantias
                        bandera:false,//con comision
                        bandIsin:false,
                        bandCuenta:false,
                        par:3,//tipo de reporte
                        fechaInicial: this.state.filters.startDate.getDate() + "-" +
                            (this.state.filters.startDate.getMonth() + 1) + "-" +
                            this.state.filters.startDate.getFullYear(),
                        fechaFinal: this.state.filters.finalDate.getDate() + "-" +
                            (this.state.filters.finalDate.getMonth() + 1) + "-" +
                            this.state.filters.finalDate.getFullYear(),
                    };

                    this.reportsService.getHistoricalReportCSV(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "Confirmation":
                    params = {folioPrestamo: this.state.selectedRow['folioOperacion']};
                    this.reportsService.getStartProrrogaReport(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const { dataReportTable, isLoading, expandedRows, filters, exportOptions, selectedRow, totalRecords,
            loadingPage, rows, disabledSearchButton} = this.state;
        let columns = [<Column header="Acciones"
                               body={this.historicalReportActionTemplate}
                               style={{textAlign: 'center', width: '8em'}} loadingBody={this.loadingText}/>];

        columns = columns.concat(this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           sortable={true}
                           body={col.body ? col.body : ''}
                           loadingBody={this.loadingText}
            />;
        }));

        return <HistoricalReportView
            dataReport={dataReportTable}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            selectedRow={selectedRow}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}

            totalRecords={totalRecords}
            rows={rows}
            loadingPage={loadingPage}
            onVirtualScroll={this.onVirtualScroll}


            onChangeFilters={this.onChangeFilters}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataReport={this.getDataReport}
            onSelectionChange={this.onSelectionChange}
            clearFilters={this.clearFilters}
        />
    }
};